import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
type CTAButtonProps = {
  label?: string;
  className?: string;
};
export function CTAButton({
  label = 'QUIERO CERRAR EL CICLO AHORA',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="#oferta" aria-label="Ver el precio y acceder a la oferta" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-rose-glow px-8 py-4 text-center text-sm font-bold uppercase tracking-wide text-white shadow-[0_18px_50px_-12px_rgba(232,69,95,0.7)] transition-colors hover:bg-rose-deep sm:text-base ${className}`} data-id="element-1">
      {label}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-2" />
    </motion.a>;
}